import { useLocale } from "@/atoms/localeAtom";
import { I18nextProvider, initReactI18next } from "react-i18next";
import { PropsWithChildren, useEffect } from "react";
import { createInstance } from "i18next";
import ICU from "i18next-icu";
import resourcesToBackend from "i18next-resources-to-backend";
import { get } from "lodash-es";
import { en } from "@/locales/en";
import { ru } from "@/locales/ru";
import { fr } from "@/locales/fr";
import { es } from "@/locales/es";
import { pt } from "@/locales/pt";
import { de } from "@/locales/de";

export const lng = "en";
export const fallbackLng = lng;
export const supportedLngs = [lng, "ru", "fr", "es", "pt", "de"];


const locales = { en, ru, fr, es, pt, de };

export const i18n = createInstance({
  lng,
  supportedLngs,
  fallbackLng,
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: true,
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["span"]
  },
  joinArrays: false,
  initAsync: false
})
  .use(ICU)
  .use(
    resourcesToBackend((lng: string, ns: string) =>
      get(locales, [lng, ...ns.split(/[/.]/).filter(Boolean)])
    )
  )
  .use(initReactI18next);

await i18n.init();

export function AppI18nProvider({ children }: PropsWithChildren) {
  const [locale] = useLocale();

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
